 jQuery(document).ready(function(){
           jQuery( ".grid__item .indiv-product").each(function( index ) {
               var len= jQuery(this).find('.swatches ul.swatch-view li').length;
                console.log(len);
                if(len == 1){
                  jQuery(this).find('.swatches ul.swatch-view').addClass('hidden');
                }
       
          });
       
 });